import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const faqs = [
  { q: "Como recebo o e-book?", a: "Logo após a confirmação do pagamento pela Monetizze, você recebe o acesso imediato ao PDF completo no seu e-mail. É baixar e começar no mesmo dia." },
  { q: "Serve para quem está começando do zero?", a: "Sim. O guia foi criado exatamente para quem está dando os primeiros passos: ele começa pelo mínimo necessário e avança capítulo a capítulo, sem pressupor experiência anterior." },
  { q: "Por quanto tempo tenho acesso?", a: "Para sempre. O pagamento é único e o acesso ao e-book é vitalício, incluindo todos os checklists e exercícios." },
  { q: "Funciona mesmo sem experiência com redes sociais?", a: "Funciona. O método transforma informação solta em um caminho prático: rotina, calendário de conteúdo, métricas que importam e a busca pelos primeiros clientes — tudo passo a passo." },
  { q: "E se eu não gostar?", a: "Você tem 7 dias de garantia incondicional. Basta pedir o reembolso pela plataforma e devolvemos 100% do valor, sem perguntas." },
];

const FAQ = () => (
  <section data-testid="faq-section" className="relative px-6 py-28 sm:py-36 lg:px-12">
    <div className="mx-auto max-w-3xl">
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
      >
        <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Perguntas frequentes</p>
        <h2 className="font-serif-display mt-6 text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl">
          Antes de virar a <span className="italic text-[#D4AF37]">primeira página.</span>
        </h2>
      </motion.div>

      <motion.div
        className="mt-16"
        initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8, delay: 0.1 }}
      >
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="border-b border-[rgba(255,255,255,0.08)]"
            >
              <AccordionTrigger className="py-7 text-left font-serif-display text-lg font-semibold text-white hover:text-[#D4AF37] hover:no-underline sm:text-xl [&[data-state=open]]:text-[#D4AF37]">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="pb-7 text-sm leading-relaxed text-[#A1A1AA] sm:text-base">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);

export default FAQ;
